import styled from 'styled-components'

export const Tag = styled.div`
  ${({ theme: { colors, breakpoint, monoFont } }) => `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  text-align: center;
  text-transform: lowercase;
  font-family: ${monoFont};
  background: ${colors('chrome')};
  color: ${colors('text')};
  border: 1px solid ${colors('foreground', 0.15)};
  padding: 0.15rem 0.5rem;
  font-size: 0.7rem;
  overflow: hidden;
  height: 1.5rem;
  margin: 0.25rem 0.75rem 0.25rem 0;
  white-space: nowrap;
  letter-spacing: 0.04em;
  &.on,
  &.active,
  &.live{
    background: ${colors('link', 0.15)};
    border-color: ${colors('link', 0.5)};
    color: ${colors('link')};
  }
  &.warning{
    background: ${colors('warning', 0.15)};
    border-color: ${colors('warning', 0.5)};
    color: ${colors('warning')};
  }
  &.accent{
    background: ${colors('accent', 0.15)};
    border-color: ${colors('accent', 0.5)};
    color: ${colors('accent')};
  }
  &.success{
    background: ${colors('success', 0.15)};
    border-color: ${colors('success', 0.5)};
    color: ${colors('success')};
  }
  @media only screen and (max-width: ${breakpoint('sm')}) {
    padding: 0 0.5rem;
    line-height: 1rem;
  }
`}
`
